/* eslint-disable no-nested-ternary */
/* eslint-disable import/prefer-default-export */

import INTENT_TYPES from "../../../constants/intentTypes";

export function normalizeBenefitResponse(apiResponse) {
  const output = apiResponse?.output_text;

  // ---- Fallback: no output at all ----
  if (!output) {
    return {
      type: "text",
      text: apiResponse.response || "I’ve processed your request.",
      outputText: apiResponse,
      agentId: apiResponse?.agent,
      summary: "",
      input_record: null,
      matches: [],
    };
  }

  // ---- Error from agent ----
  if (output.ok === false) {
    return {
      type: "error",
      summary: output.summary || output.error?.message || "",
      outputText: output,
      error: output.error,
      agent: apiResponse?.agent,
    };
  }

  // ---- IMPORTANT FIX ----
  // Different agents return matches under different keys
  const matches = Array.isArray(output.matches)
    ? output.matches
    : Array.isArray(output.data_sources_matches)
      ? output.data_sources_matches
      : [];

  // ---- Identify duplicate-style intents ----
  const isDuplicateIntent = output.intent?.toLowerCase().includes(INTENT_TYPES.DUPLICATE)
    || output.intent?.toLowerCase().includes(INTENT_TYPES.DOB_CHECK)
    || matches.length > 0;

  const type = isDuplicateIntent
    ? "duplicate_result"
    : output.intent?.includes(INTENT_TYPES.CLUSTER)
      ? "cluster"
      : "run_summary";

  let summaryText = apiResponse?.response || "";
  if (output.source_case_id && summaryText) {
    summaryText = summaryText.replace(
      /\*\*Duplicate-of-Benefits Matching Summary\*\*/g,
      `**Duplicate-of-Benefits Matching Summary: ${output.source_case_id}**`,
    );
  }
  return {
    type,
    agentId: apiResponse?.agent,
    agent: apiResponse?.agent,

    summary: summaryText,

    // ---- Intake / source case ----
    input_record: output.source_case_id
      ? {
        CaseID: output.source_case_id,
        IntakeOrigin: output.source_db || "Benefits",
      }
      : null,

    // ---- Table data ----
    matches,

    // ---- Optional fields (safe defaults) ----
    clusters: output.clusters || [],
    counts: output.counts || null,
    intent: output.intent,
    filters: output.filters,

    sourceCaseId: output.source_case_id,
    sourceDb: output.source_db,

    // ---- Keep raw payload for debugging ----
    outputText: apiResponse,
  };
}
